import { ConnectionStatus } from '../types';

const TIME_CONSTANTS = {
  SECOND: 1000,
  MINUTE: 60 * 1000,
  HOUR: 60 * 60 * 1000,
} as const;

const UPDATE_THRESHOLDS = {
  RECENT: 60,
  MINUTES: 60 * 60,
} as const;

export function formatLastUpdate(
  lastDataUpdate: Date | null | undefined,
): string {
  if (!lastDataUpdate) {
    return 'Never';
  }

  const now = Date.now();
  const updateTime = lastDataUpdate.getTime();
  const diffSeconds = Math.floor((now - updateTime) / TIME_CONSTANTS.SECOND);

  if (diffSeconds < UPDATE_THRESHOLDS.RECENT) {
    return 'Updated less than a minute ago';
  }

  const minutes = Math.floor(diffSeconds / 60);
  if (minutes < 60) {
    return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
  }

  const days = Math.floor(hours / 24);
  return days === 1 ? '1 day ago' : `${days} days ago`;
}

export function getStatusLabel(
  connectionStatus: ConnectionStatus,
  topicCount = 0,
): string {
  const labels: Record<ConnectionStatus, string> = {
    connected:
      topicCount > 0 ? `Live Data (${topicCount} topics)` : 'Live Data',
    disconnected: 'Offline',
    reconnecting: 'Reconnecting...',
  };

  return labels[connectionStatus];
}
